module.exports = __webpack_public_path__ + "static/media/Mogo.662a03da.png";